var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMic28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8995_218040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3231 2C11.6721 2 9.52307 4.14903 9.52307 6.8V12.8C9.52307 15.451 11.6721 17.6 14.3231 17.6C16.974 17.6 19.1231 15.451 19.1231 12.8V6.8C19.1231 4.14903 16.974 2 14.3231 2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04322 14C5.3816 14 4.86498 14.5828 5.03149 15.2231C6.0174 19.0143 9.26229 21.8943 13.2431 22.3399V24.92C13.2431 25.5165 13.7266 26 14.3231 26C14.9195 26 15.4031 25.5165 15.4031 24.92V22.3399C19.3839 21.8943 22.6288 19.0143 23.6147 15.2231C23.7812 14.5828 23.2646 14 22.6029 14C22.0633 14 21.6119 14.3948 21.4589 14.9123C20.5486 17.9925 17.6983 20.24 14.3231 20.24C10.9479 20.24 8.09756 17.9925 7.18721 14.9123C7.03426 14.3948 6.58284 14 6.04322 14Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8995_218040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic28);
export default __webpack_public_path__ + "static/media/mic_28.7bb2e9ec.svg";
export { ForwardRef as ReactComponent };